import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';
import './filterChips.css';

/* FilterChips — the applied-filter line (`.br-chips`).

   This component owns the markup and nothing else: removal is the caller's,
   because one pill can represent a whole GROUP of values and removing it has to
   unpick both the filter state and the URL.

   It renders nothing when nothing is applied, rather than an empty row: an empty
   `.br-chips` still spends its 16px bottom margin and pushes the grid down. */
export default function FilterChips({ chips, onClearAll, clearLabel, className }) {
  if (!chips || chips.length === 0) return null;

  return (
    <div className={`br-chips${className ? ` ${className}` : ''}`}>
      {chips.map((c) => (
        <span className="br-chip" key={c.id}>
          {c.group && <b>{c.group}:</b>}
          {c.label}
          {c.onRemove && (
            <button
              type="button"
              onClick={() => c.onRemove(c.id)}
              aria-label={`Remove ${c.group ? `${c.group} ` : ''}${c.label} filter`}
            >
              <X aria-hidden="true" />
            </button>
          )}
        </span>
      ))}

      {onClearAll && (
        <button className="br-clear" type="button" onClick={onClearAll}>
          {clearLabel}
        </button>
      )}
    </div>
  );
}

FilterChips.propTypes = {
  chips: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    /** The filter this value came from — "Category", "Price". */
    group: PropTypes.string,
    label: PropTypes.node.isRequired,
    /** Called with the chip's id. Omit for a chip that cannot be removed. */
    onRemove: PropTypes.func,
  })),
  onClearAll: PropTypes.func,
  clearLabel: PropTypes.string,
  className: PropTypes.string,
};

FilterChips.defaultProps = { chips: [], clearLabel: 'Clear all' };
